<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
  export default {
    name: "App",
  };
</script>
<style lang="scss">
  .el-picker-panel.no-atTheMoment {
    .el-button--text.el-picker-panel__link-btn {
      display: none;
    }
  }
</style>
<style>
  @media (max-width: 480px) {
    .el-message-box {
      display: inline-block;
      width: 70%;
      height: 10%;
      padding-bottom: 20px;
      vertical-align: middle;
      background-color: #FFF;
      border-radius: 8px;
      border: 4px solid #EBEEF5;
      font-size: 48px;
      -webkit-box-shadow: 0 0.01212rem 0.07273rem 0 rgba(0, 0, 0, .1);
      box-shadow: 0 0.01212rem 0.07273rem 0 rgba(0, 0, 0, .1);
      text-align: left;
      overflow: hidden;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
    }

    .el-message_content {
      font-size: 32px !important;
      color: red;
    }

    .el-message-box__content {
      padding: 30px 20px;
      color: #606266;
      font-size: 48px;
    }

    .el-message-box__status {
      position: absolute;
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      font-size: 48px !important;
    }

    .el-message-box__status.el-icon-warning {
      color: #E6A23C;
      font-size: 48px;
      /* margin-right: 80px !important; */
    }

    .el-message-box__btns {
      padding: 14px;
      text-align: right;
      font-size: 48px;
    }

    .el-message-box__btns {
      padding: 0.0303rem 0.09091rem 0;
      text-align: right;
    }

    .el-button {
      font-size: 40px;
      padding: 18px;
    }

    .el-dialog__body {}
  }
</style>